import { render, staticRenderFns } from "./savoir_plus.vue?vue&type=template&id=780e616b&scoped=true&"
import script from "./savoir_plus.vue?vue&type=script&lang=js&"
export * from "./savoir_plus.vue?vue&type=script&lang=js&"
import style0 from "./savoir_plus.vue?vue&type=style&index=0&id=780e616b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780e616b",
  null
  
)

export default component.exports